import {Component, HostListener, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BaseComponent,
  WmsDialogBodyComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent, WmsMessageComponent, WmsSpinnerComponent, WmsTypeaheadComponent, WmsWizardComponent
} from "@wms/components";
import {DialogService, NotificationService, PrefabService} from "@wms/services";
import {FormsModule} from "@angular/forms";
import {VcsService} from "@wms/app/vcs/services/vcs.service";
import {replace} from "@wms/core";
import {VcsAPIService} from "@wms/app/vcs/services/vcs-api/vcs-api.service";
import {get, isEqual, isObject, uniqBy} from "lodash-es";
import { EventManagerService } from '@wms/app/event-manager';
const semver = require("semver");

@Component({
  selector: 'wms-publish-to-workspace',
  standalone: true,
  imports: [CommonModule, WmsDialogBodyComponent, WmsDialogFooterComponent, WmsDialogHeaderComponent, WmsWizardComponent, WmsMessageComponent, WmsTypeaheadComponent, FormsModule, WmsSpinnerComponent],
  templateUrl: './publish-to-workspace.component.html',
  styleUrls: ['./publish-to-workspace.component.less']
})
export class PublishToWorkspaceComponent extends BaseComponent implements OnInit {
  project_details: any;
  publishDetails: any;
  projectDefaults: any;
  showCommitMsg: boolean;
  vcsCommitMsg: any;
  showErrMsg: boolean;
  isSyncRequired: boolean;
  loadingData: boolean;
  errMsg: any;
  projectVersion: string;
  categories: any[];
  currentVersion: string;
  suggestedVersions: any[];
  tooltipVisible: boolean;

  constructor(private dialogService: DialogService, private vcsService: VcsService, private vcsAPIService: VcsAPIService,
              private prefabService: PrefabService, private notificationService: NotificationService,private eventManagerService: EventManagerService) {
    super();
    this.eventManagerService.publishToWorkspaceObservable().subscribe(()=>{
      this.ngOnInit()
    })

  }

  ngOnInit() {
    this.publishDetails = {};
    this.projectDefaults = {};
    this.categories = [];
    this.suggestedVersions = [];
    this.isSyncRequired = this.preferences.project?.vcs.view;
    this.loadingData = true;
    this.tooltipVisible = false;
    this.prepareForDisplay().then(() => {
      if(this.isSyncRequired) {
        this.showCommitMsg = true;
        this.vcsService.setVCSCommitMsg(true).then(() => {
          this.vcsCommitMsg = this.vcsService.vcsCommitMsg;
          this.loadingData = false;
        })
      }
    });
  }



  closeModal() {
    this.dialogService.close('publish-to-workspace');
    this.vcsService.pushActionCB = () => {}
    this.showErrMsg = false;
  }

  async prepareForDisplay(): Promise<void> {
    await this.populatePrefabCategories();
    this.setData();
    return;
  }
  publishChangesToWorkspace() {
    let commitMsg = this.publishDetails.commitMsg ? this.publishDetails.commitMsg + '\n' + this.vcsCommitMsg : this.vcsCommitMsg,
        data = {
          projectDetails: { ...this.project_details.properties, copyright: this.project_details.properties.copyrightMsg, version: this.publishDetails.version }
        };
    this.project_details.version  = this.publishDetails.version;
    this.showErrMsg           = false;
    (this.projectService.updateDetails(data) as Promise<any>).then(() => {
      let payLoad = {
        'projectID' : this.project_details.studioProjectId || this.project_details.id,
        'name'      : this.project_details.name,
        'category'  : this.publishDetails.category,
        'version'   : this.publishDetails.version
      };
      if (this.isSyncRequired) {
        //if vcs is available then push the project first then publish the project
        let vcsParams:any = {}
         vcsParams.commitMessagePrefix = commitMsg
          this.vcsAPIService.pushChanges(vcsParams).then(() => {
            this.publishPrefabToWorkspace(payLoad);
          }).catch((error: any) => this.publishErrorHandler(error));
      } else {
        this.publishPrefabToWorkspace(payLoad);
      }
    }).catch((error: any) => this.publishErrorHandler(error));
  }

  publishPrefabToWorkspace(payload: any){
    this.projectService.publishToWorkSpace(payload).then(() => this.publishSuccessHandler(), (error: any) => this.publishErrorHandler(error));
  }

  publishSuccessHandler() {
    this.closeModal();
    this.notificationService.show('success', this.locale.MESSAGE_SUCCESS_TITLE, this.locale.MESSAGE_PUBLISH_SUCCESS);
  }

  publishErrorHandler(errMsg: string) {
    this.showErrMsg = true;
    const parameters: string | undefined = get(errMsg, 'error.errors.error[0].parameters[0]');
    this.errMsg = {
      type: 'error',
      caption: !isObject(errMsg) ? errMsg : replace(get(errMsg, 'error.errors.error[0].message'),   parameters !== undefined ? (parameters as string).split(',') : undefined, true)
    }
  }

  showValidation(newValue: string) {
    this.publishDetails.version = newValue;
    if (semver.valid(newValue) !== null && this.publishDetails.version.length <= 40) {
      // if prefab new version is valid then check if new version is greater than current version
      if (semver.compare(this.publishDetails.version, this.currentVersion) === 1) {
        this.showErrMsg             = false;
        this.publishDetails.isValid = true;
      } else if(semver.compare(this.publishDetails.version, this.currentVersion) === 0) { // compare() returns 0 if both the versions match except build metadata
        this.publishDetails.isValid         = false;
        this.showErrMsg                     = true;
        this.errMsg                         =  this.locale.MSG_PUBLISH_PREFAB_VERSION_CONFLICT_4.replace('${0}', this.publishDetails.version).replace('${1}', this.currentVersion);
        this.publishErrorHandler(this.errMsg);
      } else if (isEqual(this.publishDetails.version, this.currentVersion)) {
        // check if current version and new version are same
        this.publishDetails.isValid = false;
        this.showErrMsg                     = true;
        this.errMsg                         = this.locale.MSG_PUBLISH_PREFAB_VERSION_CONFLICT_1;
        this.publishErrorHandler(this.errMsg);
      } else { // if new version is less than current version
        this.showErrMsg             = true;
        this.publishDetails.isValid = false;
        this.errMsg                 = this.locale.MESSAGE_ERROR_PUBLISH_PREFAB_VERSION;
        this.publishErrorHandler(this.errMsg);
      }
    } else {
      this.showErrMsg             = true;
      this.publishDetails.isValid = false;
      this.errMsg                 = this.publishDetails.version.length > 40 ?  this.locale.MSG_PUBLISH_PREFAB_VERSION_CONFLICT_3: this.locale.MSG_PUBLISH_PREFAB_VERSION_CONFLICT_2;
      this.publishErrorHandler(this.errMsg);
    }
  }
  setExistingCategory(name: string, category: string) {
    if (this.projectDefaults.name === name && (category && category !== null)) {
      this.publishDetails.category = category;
    }
  }

  async populatePrefabCategories() {
    (this.prefabService.list() as Promise<any>).then((prefabs: any) => {
      prefabs.forEach((prefab: any) => {
        this.setExistingCategory(prefab.name, prefab.category);
        if(prefab.category && prefab.category !== null && this.categories.indexOf(prefab.category) === -1) {
          this.categories.push(prefab.category)
        }
      });
    });
  }
  addToSuggestedVers(version: string) {
    this.suggestedVersions.push({
      version: version,
      category: this.locale.LABEL_SUGGESTED_VERSIONS
    });
  }

  populateSuggestedVersions(currentVersion: string) {
      this.addToSuggestedVers(semver.inc(currentVersion, 'patch'));
      this.addToSuggestedVers(semver.inc(currentVersion, 'minor'));
      this.addToSuggestedVers(semver.inc(currentVersion, 'major'));
      this.suggestedVersions = uniqBy(this.suggestedVersions, 'version');
  }

  setData() {
    this.project_details = this.projectService.getDetails();
    //assign the default values necessary for the dom display
    this.projectVersion = isNaN(parseFloat(this.project_details.version)) ? '1.0.0' : this.project_details.version;
    let projectVersionParts = this.projectVersion.split(".");
    this.currentVersion = projectVersionParts.length == 2 ? this.projectVersion + '.0' : (projectVersionParts.length == 1 ? this.projectVersion + '.0.0': this.projectVersion);
    this.populateSuggestedVersions(this.currentVersion);

    this.projectDefaults = {
      'name'          : this.project_details.name,
      'category'      : this.project_details.category || "",
      'version'       : this.currentVersion
    };
    //assign the default upgraded version to be +.1
    this.publishDetails = {
      'isValid'       : true,
      'category'      : this.projectDefaults.category,
      'version'       : ""
    };
  }

  setCategory($event: any) {
    this.publishDetails.category = $event.value || $event;
  }

  unsetCategory(){
    this.publishDetails.category = ''
  }

  setNewVersion($event: any) {
    this.showValidation( $event.value || $event);
  }
   unsetNewVersion() {
     this.publishDetails.version = '';
     this.publishDetails.isValid = false;
   }
  toggleTooltip() {
    this.tooltipVisible = !this.tooltipVisible;
  }

  // hide semantic version helptext on outside click
  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    if (event.target instanceof HTMLElement) {
      if (!event.target.closest('.wms-help') && !event.target.closest('.wms-clear')) {
        this.tooltipVisible = false;
      }
    }
  }
}
